/**
 * Given an object select the property at the given path without having to check at each level.
 * So instead of doing:
 *
 * @example
 * // before
 * const x = someObject.blah || {};
 * const y = x.prop || {};
 * const z = y.otherProp;
 *
 * // after
 * const z = safeSelect(someObject, 'blah.prop.otherProper');
 *
 * @param {Object} state - the object to select from
 * @param {string|Array} stateUpdates.path - the path of the state to select from
 * @returns {*} the selected state or undefined if not found
 */
export default function safeSelect(state, path) {
  var delimiter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!state) return undefined;
  var guardedPath = path || [];
  var pathSegments = typeof guardedPath === 'string' ? guardedPath.split(delimiter) : guardedPath;

  if (pathSegments.length === 0) {
    return state;
  }

  if (pathSegments.length === 1) {
    return state[pathSegments[0]];
  }

  var nextSegment = pathSegments.splice(0, 1);
  return safeSelect(state[nextSegment] || {}, pathSegments);
}